export const language = {
    "Custom Design": "Diseño Personalizado",
    "Cancel": "Cancelar",
    "Update": "Actualizar",
    "Save": "Guardar",
}